import { useSelector } from 'react-redux';
import { selectLanguage, selectDefaultLanguage } from '../app/reducers/language';
import { selectTranslations } from '../app/reducers/translations';

export const useTranslation = () => {
  const language = useSelector(selectLanguage);
  const defaultLanguage = useSelector(selectDefaultLanguage);
  const translations = useSelector(selectTranslations);

  const resolveKey = (key) => {
    const keys = key.split('.');
    let value = translations[language];

    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return undefined;
      }
    }

    return (typeof value === 'string' || typeof value === 'number') ? value : undefined;
  };

  const normalizeNewlines = (value) => {
    if (typeof value !== 'string') return value;
    return value.replace(/\\n/g, '\n');
  };

  const t = (key) => {
    const resolved = resolveKey(key);
    return normalizeNewlines(resolved !== undefined ? resolved : key);
  };

  const tMixed = (text) => {
    if (!text) return text;
    return normalizeNewlines(text.replace(/i18n_([\w.]+)/g, (match, key) => t(key)));
  };

  const tBackend = (entry) => {
    if (!entry) return '';
    const content = normalizeNewlines(entry.content || '');
    const i18nContent = entry.i18nContent;
    if (!i18nContent) return content;

    const strippedKey = i18nContent.replace(/i18n_/g, '');
    const resolved = tMixed(i18nContent);
    const hasTranslation = resolved && resolved !== strippedKey;

    if (hasTranslation) return resolved;
    if (language === defaultLanguage) return content;
    return resolved;
  };

  return { t, tMixed, tBackend, language, defaultLanguage };
};
